import React, { Fragment,useState } from 'react'
import FilterConfirmation from '../../FormFields/FilterConfirmationComponent/FilterConfirmation';
import LoaderComponent from '../../FormFields/LoaderComponent/LoaderComponent'

export default function MessageA62(props) {


  const {handleClick,item,tag} = props;
 
  const [apllied, setApplied] = useState(true);
  const handleFilterApplied = (data) => {
    setApplied(data);
  };
 
  return (
    <Fragment>
{apllied ?<LoaderComponent
time={JSON.parse(item.data).waitSecs}
onClickSubmit={(code,data,tag) =>{
  props.handleClick(code,data);
}}
tag={tag}
 code={item.code}
filterToggle={(data) => {
  handleFilterApplied(data);
}}

 /> : <FilterConfirmation 
 mainText1={"Packs Selected"}
 mainText1Data={JSON.parse(localStorage.getItem("selectedChannelsPAcks"))?.packName}  /> }
      

     
    </Fragment>
  )
}
